import React from "react";
import Icon from "../../../components/AppIcon";
import FakeAppChrome from "../FakeAppChrome";
import { GUIDED_TOUR_CTA_LABEL } from "../constants";

const CloseScene = () => (
  <FakeAppChrome activeNavId="home">
    <div className="flex h-full min-h-[320px] items-center justify-center p-6 sm:p-10">
      <div className="w-full max-w-lg rounded-xl border border-border bg-card p-6 sm:p-8 shadow-elevation-sm text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 mb-4">
          <Icon name="Rocket" size={24} className="text-primary" />
        </div>
        <h3 className="text-2xl font-bold tracking-tight text-foreground">
          Comece a usar agora
        </h3>
        <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
          Crie sua conta gratuita em apps.neomodelos.com.br e explore o sistema
          completo — modelos, IA, PDF, assinatura, CRM e WhatsApp.
        </p>
        <div className="mt-6 inline-flex h-12 items-center justify-center rounded-lg bg-primary px-8 text-base font-semibold text-primary-foreground shadow-soft-sm">
          {GUIDED_TOUR_CTA_LABEL}
        </div>
        <p className="mt-3 text-xs text-muted-foreground">
          Use o botão abaixo para continuar
        </p>
      </div>
    </div>
  </FakeAppChrome>
);

export default CloseScene;
